/* istanbul ignore file */

import 'youbora-adapter-videojs';

import vjs from 'video.js';
import * as youbora from 'youboralib';

import { updateOptions } from './index';

export const ExtendedAdapter = youbora.adapters.Videojs.extend({
  getPlayerVersion: function (): string {
    return `web_videojs_8}`;
  },
  registerListeners: function () {
    youbora.Log.notice('Registering listeners');
    ExtendedAdapter.__super__.registerListeners.apply(this);

    const overrides = {
      ended: () => this.conditionalStop(),
      play: () => this.playListener(),
      adspause: () => console.log('Ads pause event'),
      adsready: (...event: any[]) => this.onAdsPlay(...event),
      'ads-play': (...event: any[]) => this.onAdsPlay(...event),
    };

    for (const [e, listener] of Object.entries(overrides)) {
      if (this.references[e]) {
        this.player.off(e, this.references[e]);
      }
      this.references[e] = this.player.on(e, listener);
    }
  },
  onAdsPlay: function (event: any, payload: any) {
    if (!payload) {
      return;
    }
    if (payload.impressionType === 'VIDEO') {
      updateOptions({
        'ad.title': payload.adName,
        'ad.resource': payload.variant,
      });
    }
    console.log(payload);
  },
  isOnAdBreak(): boolean {
    if (
      this.player.ads &&
      this.player.ads.inAdBreak &&
      this.player.ads.inAdBreak()
    ) {
      return true;
    }
    return false;
  },
  conditionalStop: function () {
    if (this.isOnAdBreak()) {
      return;
    }
    ExtendedAdapter.__super__.conditionalStop.apply(this);
  },

  playListener: function () {
    if (this.isOnAdBreak()) {
      return;
    }
    ExtendedAdapter.__super__.playListener.apply(this);
  },
});
